<template>
  <div id="segunda-via">
    <nav class="navbar navbar-expand-md fixed-top bg-transparent navbar-light">
      <div class="collapse navbar-collapse" id="main-menu"></div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#main-menu"
        aria-controls="main-menu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>

    <!-- Modals -->
    <LoginFastAccessModalCompletoLojista />
    <CadastroModal></CadastroModal>
    <NovaSenhaModal></NovaSenhaModal>

    <div class="via-facil">
      <div class="container">
        <div class="content">
          <div>
            <div class="icones">
              <img src="img/icon-menu-contratos.png" width="65" height="65" class="Meus contratos"/>
            </div>
          </div>
           <div>
            <h5><b>DIGIMAISFÁCIL</b></h5>
            <p style="font-size: 1.4rem"> 
              Seja bem-vindo ao portal de cobrança do Digi+!
            </p>
            <p style="font-size: 1.2rem"> 
              Clique no botão abaixo, e acesse com o CPF do cliente e seu usuário:<br/><br/>
            </p>
            <a
              class="btn-boleto"
              href="forms/login-form-Fast.html"
              data-remote="false"
              data-toggle="modal"
              data-target="#login-modal-Fast-Completo-Lojista"
              >Acessar contratos
            </a>
            <br/>
            <br/>
            <p style="font-size: 1rem"> 
              Ou<br/><br/>
              Entre em contato com as nossas centrais de atendimento: <br/>4020 3300 | 0800 646 7676, de segunda a sexta das 8h às 20h e sábados das 8h às 14h (exceto feriados).
            </p>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import CadastroModal from "../components/CadastroModal";
import NovaSenhaModal from "../components/NovaSenhaModal";
import LoginFastAccessModalCompletoLojista from "../components/LoginFastAccessModalCompletoLojista";

export default {
  name: "Admin",
  components: {
    LoginFastAccessModalCompletoLojista,
    CadastroModal,
    NovaSenhaModal,
  },
  mounted() {
    var modal_needfix = true;
    $(".modal").on("shown.bs.modal", function () {
      var modalscope = $(this);
      modalscope.css({ paddingRight: "" });
      if (modal_needfix) {
        window.addEventListener("resize", function () {
          requestAnimationFrame(function () {
            // be sure to act after the pluggin script
            modalscope.css({ paddingRight: "" });
          });
        });
        modal_needfix = false;
      }
    });

    const self = this;
    setTimeout(function () {
      var element = document.getElementById("popupModal");

      if (element != null) {
        if (!self.hasClass(element, "openModal")) {
          element.classList.add("openModal");
        }
      }
    }, 1000);
  },
  methods: {
    // showLogin(event) {
    //   if (event) {
    //     event.preventDefault();
    //   }
    //   EventBus.$emit("eventShowLogin");
    // },
    // showCadastro: function (event) {
    //   if (event) {
    //     event.preventDefault();
    //   }
    //   EventBus.$emit("eventShowCadastro");
    // },
    showLoginFast: function (event) {
      if (event) {
        event.preventDefault();
      }
      EventBus.$emit("eventShowLoginFast");
    },
  },
};
</script>
<style>
</style>
